import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=4ba88b3a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=4ba88b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba88b3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba88b3a')) {
      api.createRecord('4ba88b3a', component.options)
    } else {
      api.reload('4ba88b3a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=4ba88b3a&scoped=true&", function () {
      api.rerender('4ba88b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2msjqBzMYW8He/JS/teamMember.vue"
export default component.exports